<template lang="pug">
  div
    client-list.box(
      @selected="selected"
      @deselected="deselected"
    )

    client-contact-list.box(
      v-if="seleccionado"
      :cliente="clienteSeleccionado"
    )

    client-equipo-list.box(
      v-if="seleccionado"
      :cliente="clienteSeleccionado"
    )

</template>

<script>
import ClientList from './Component_Cliente_List'
import ClientContactList from './Component_Cliente_Contact_List'
import ClientEquipoList from './Component_Cliente_Equipo_List'
export default {
  name: 'client_admin',
  components: {
    ClientList,
    ClientContactList,
    ClientEquipoList
  },
  data () {
    return {
      empresa               : process.env.EMPRESA,
      empresa_full          : process.env.EMPRESA_FULL,
      clienteSeleccionado   : {},
      seleccionado          : false
    }
  },
  created () {
  },
  methods: {
    selected (cliente) {
      this.clienteSeleccionado.codigo = cliente.codigo
      this.clienteSeleccionado.nombre = cliente.nombre
      this.seleccionado = true
    },
    deselected (cliente) {
      this.clienteSeleccionado = {}
      this.seleccionado = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import('https://cdnjs.cloudflare.com/ajax/libs/bulma/0.4.4/css/bulma.min.css')
.message
  margin-top 10px

.tickets-container
  display flex

.ticket-summary-box.box
  margin-bottom 0px
  margin 10px 10px 0px 10px

.section-tickets-cerrados
  margin-top 10px

.title-section
  font-size 20px
  text-align center
  margin-bottom 0px
  font-weight bold

.flex-direction-column
  flex-direction column

</style>



// WEBPACK FOOTER //
// View_Cliente_Admin.vue?2126c574